import React from "react";
import { Box } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import I18nText from "../../../elements/I18nText";

const ExportDateRange = ({ from, to, onChangeFrom, onChangeTo }) => (
  <Box display="flex" mt={1} style={{ gap: 8 }}>
    <KeyboardDatePicker
      size="small"
      variant="dialog"
      inputVariant="outlined"
      ampm={false}
      fullWidth
      disableFuture
      format="dd.MM.yyyy"
      label={<I18nText>devices.export.range.from</I18nText>}
      value={from}
      onChange={date => onChangeFrom(date)}
    />
    <KeyboardDatePicker
      size="small"
      variant="dialog"
      inputVariant="outlined"
      ampm={false}
      fullWidth
      disableFuture
      format="dd.MM.yyyy"
      label={<I18nText>devices.export.range.to</I18nText>}
      value={to}
      onChange={date => onChangeTo(date)}
    />
  </Box>
);

export default ExportDateRange;
